import { Injectable } from '@angular/core';
import { apiUrl } from '../config/api';
import { NewsItem } from '../models/news';

@Injectable({ providedIn: 'root' })
export class NewsService {
  private readonly apiUrl = apiUrl('/api/news');

  listPublished(): Promise<NewsItem[]> {
    return this.request<NewsItem[]>(this.apiUrl);
  }

  listAdmin(): Promise<NewsItem[]> {
    return this.request<NewsItem[]>(`${this.apiUrl}/admin`);
  }

  get(id: number): Promise<NewsItem> {
    return this.request<NewsItem>(`${this.apiUrl}/${id}`);
  }

  create(news: Partial<NewsItem>): Promise<NewsItem> {
    return this.request<NewsItem>(this.apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(news)
    });
  }

  update(id: number, news: Partial<NewsItem>): Promise<NewsItem> {
    return this.request<NewsItem>(`${this.apiUrl}/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(news)
    });
  }

  publish(id: number): Promise<NewsItem> {
    return this.request<NewsItem>(`${this.apiUrl}/${id}/publish`, { method: 'PATCH' });
  }

  unpublish(id: number): Promise<NewsItem> {
    return this.request<NewsItem>(`${this.apiUrl}/${id}/unpublish`, { method: 'PATCH' });
  }

  async delete(id: number): Promise<void> {
    await this.request<{ success: boolean }>(`${this.apiUrl}/${id}`, { method: 'DELETE' });
  }

  private async request<T>(url: string, init?: RequestInit): Promise<T> {
    const response = await fetch(url, { cache: 'no-store', ...init });
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(data?.error ?? 'Errore API');
    }

    return data as T;
  }
}
